import menu from './menu';
import page from './page'
export default {
	...menu,
	...page
};
